import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    top: '50px',
  },
  rootAlert: {
    display: 'flex',
  },
  message: {
    maxWidth: '97%',
    whiteSpace: 'pre-line',
  },
  iconButton: {
    backgroundColor: 'black',
    opacity: '0.5',
    padding: '2px',
    borderRadius: '50%',
    marginLeft: '10px',
  },
  closeIcon: {
    width: '16px',
    height: '16px',
  },
}), { name: 'notification' });
